<script lang="ts">
	export let index: number;
	export let imageSrc: string;
	export let imageAlt: string = '';
</script>

<img
	class="w-full rounded-lg h-full object-cover"
	style={`grid-area: image${index}`}
	src={imageSrc}
	alt={imageAlt}
/>
